































import VueOptions from '@utils/VueOptions'
import RecessAPI from '@services/RecessAPI'
import Selector from '@ui/Inputs/Selector'
import TagBar from '@ui/TagBar'

settings =
  name: 'SupplierSelector'

  vue:
    props: ['selectedOptions', 'theme', 'actions']
    components: { Selector, TagBar }

    data: ->
      supplierOptions: []

    mounted: ->
      @searchSupplier()

    computed:
      selectorActions: -> { ...@actions, search: @searchSupplier }

      selectorOptions: ->
        {
          searchBoxPlaceholder: 'Search by name',
          selectOptionsTitle: false,
        }

      normalizedSelectedOptions: ->
        @selectedOptions.map((supplier) -> { key: supplier.id, ...supplier })

      selectedKeys: -> @selectedOptions.map((supplier) -> supplier.id)

      tagBarOptions: ->
        {
          bar: {
            theme: 'selector',
            max: 3,
          },
          tag: {
            theme: 'selector',
            maxLength: 8
          },
          initializeExpanded: false,
        }

      containerWidth: -> document.querySelector('.supplier-set-selector').offsetWidth - 65 || 250

    methods:
      searchSupplier: (value = '') ->
        text = value.trim()
        @supplierOptions = []
        suppliers = await RecessAPI.search 'suppliers', { text, per_page: 100, top_org_only: true }
        options = []
        for supplier in suppliers
          options.push({
            key: supplier.id,
            value: supplier.name,
            type: 'supplier',
            sortBy: "#{supplier.name}",
            data: supplier
          })
        @supplierOptions = options.sort((a, b) -> "#{a.value}".localeCompare("#{b.value}"))

      clearSearch: ->
        @$refs.selector.clearSearch()

export default VueOptions.vue settings
